export default __webpack_public_path__ + "static/media/img-card.c9c362c1.png";